export const zh = {
  title: '土地覆盖 2000-2020',
  subtitle: 'UMD',
  download_data: '',
  learn_more: '',
  content: [
    {
      label: '功能',
      value: '全球 2000 年和 2020 年土地利用和土地覆盖（LULC）地图',
    },
    {
      label: '分辨率',
      value: '30 米分辨率',
    },
    {
      label: '地理覆盖范围',
      value: '全球',
    },
    {
      label: '来源',
      value: 'UMD',
    },
    {
      label: '更新频率',
      value: '',
    },
    {
      label: '内容日期',
      value: '',
    },
    {
      label: '注意事项',
      value:
        '-由于 Landsat 晴空数据的可用性限制了土地覆盖制图，在持续云覆盖的地区，Landsat 观测时间序列的不完整性会降低地图的准确性。\n-在异质景观中，离散土地覆盖类别的映射受到 Landsat 空间分辨率下混合像素比例较高的限制。相比于破碎景观和分类斑块边缘，大多数 LULC 类别在大面积均质区域的映射精度更高。\n-不同土地利用/覆盖（LCLU）类别之间的光谱相似性可能会影响类别区分的能力。\n-森林高度产品存在与 GEDI 数据质量和 Landsat 数据可用性相关的问题。在 2000 年至 2020 年期间，森林高度的小幅变化可能并不代表实际的森林结构变化，而可能是模型输出的噪声。\n-动态类别（LCLU 变化，如损失和增加）的精度通常低于静态地图。\n-由于地图的不确定性在空间和时间上的变化未知，基于地图的估算数据不适用于国家和国际报告。',
    },
    {
      label: '许可证',
      value: '许可协议：Creative Commons Attribution License',
    },
  ],
  overview: {
    label: '概览',
    value:
      '全球土地利用和土地覆盖（LULC）地图由 全球土地分析与发现实验室（GLAD） 制作，并提供 30 米分辨率的 2000 年和 2020 年数据。GLAD 实验室使用时空一致的 Landsat 预处理数据（GLAD ARD） 量化了 20 年间森林覆盖和高度、农田、建设用地、水体以及多年积雪和冰川的变化。每个专题产品均采用最先进的、本地和区域校准的机器学习工具独立生成。该数据集经过统计抽样验证，证明其具有较高的准确性。\n\nGLAD 实验室隶属于马里兰大学地理科学系，研究全球土地表面变化的方法、成因及影响。地球观测影像是 GLAD 的主要数据来源，而土地覆盖范围和变化是其主要研究主题。GLAD 的目标是：\n\n- 产生关于土地资源的新科学见解，\n- 培养下一代基于遥感的土地变化研究人员，\n- 在国内和国际范围内推广土地监测能力的实际应用。',
  },
  citation: {
    label: '引用',
    value:
      'Potapov P., Hansen M.C., Pickens A., Hernandez-Serna A., Tyukavina A., Turubanova S., Zalles V., Li X., Khan A., Stolle F., Harris N., Song X.-P., Baggett A., Kommareddy I., Kommareddy A. (2022) The global 2000-2020 land cover and land use change dataset derived from the Landsat archive: first results. Frontiers in Remote Sensing. [https://doi.org/10.3389/frsen.2022.856903](https://doi.org/10.3389/frsen.2022.856903). Accessed through Resource Watch, (date). [www.resourcewatch.org](https://www.resourcewatch.org).',
  },
};
